import {
  Actor,
  Animation,
  CollisionType,
  Color,
  GraphicsGroup,
  Sprite,
  SpriteSheet,
  Vector,
  Keys,
  Label,
  Font,
} from "excalibur";
import { Resources } from "../Resources";
import { hiveState } from "../state/stateManager";
import { getHiveSprite, roundDown } from "../utils";

export class Hive extends Actor {
  constructor(x, y, hiveStats, homeClass) {
    super({
      x: x,
      y: y,
      width: 16,
      height: 24,
      collisionType: CollisionType.Fixed,
      z: 3,
    });
    console.log("constructor for hive getting ready");
    this.birth = hiveStats.birth;
    this.swarming = false;
    this.swarmIteration = 0;
    this.flyingActor = new Actor({ pos: new Vector(0, 0), z: 10 });
    this.hiveStats = hiveStats;
    this.indicationShowing = false;
    this.outerCollider = new Actor({
      width: 18,
      height: 25,

      collisionType: CollisionType.Passive,
    });
    this.addChild(this.outerCollider);
    this.outerCollider.on("collisionend", () => {
      console.log("collision ended should kill");
      if (this.indicationShowing) {
        this.indication.classList.remove("active");
        this.indicationShowing = false;
        homeClass.removeActive();
      }
    });
    this.outerCollider.on("collisionstart", (collider) => {
      console.log("collison start should show ", collider);
      if (!this.indicationShowing && collider.other.owner.name === "player") {
        homeClass.setActive(hiveStats);
        this.createProgressIndication();
        this.indicationShowing = true;
      }
    });
    this.alive = hiveStats.alive || false;
  }
  onInitialize(engine) {
    // let hives = hiveState.getHives();
    // let theHive = hives.filter((e) => {
    //   return e.birth == this.hiveStats.birth;
    // });
    // this.hiveStats = theHive;
    // console.log("getting ready oninitialize: ", theHive);
    this.engine = engine;
    const smallHiveSrites = SpriteSheet.fromImageSource({
      image: Resources.SmallHives,
      grid: {
        spriteWidth: 16,
        spriteHeight: 16,
        rows: 10,
        columns: 6,
      },
    });
    const bigHiveSrites = SpriteSheet.fromImageSource({
      image: Resources.BigHives,
      grid: {
        spriteWidth: 16,
        spriteHeight: 32,
        rows: 10,
        columns: 6,
      },
    });
    const beeSprite = SpriteSheet.fromImageSource({
      image: Resources.Bees,
      grid: {
        spriteWidth: 16,
        spriteHeight: 16,
        rows: 2,
        columns: 10,
      },
    });
    const flying = new Animation({
      frames: [
        { graphic: beeSprite.getSprite(0, 0), duration: 100 },
        { graphic: beeSprite.getSprite(1, 0), duration: 100 },
        { graphic: beeSprite.getSprite(2, 0), duration: 100 },
        { graphic: beeSprite.getSprite(3, 0), duration: 100 },
        { graphic: beeSprite.getSprite(4, 0), duration: 100 },
        { graphic: beeSprite.getSprite(5, 0), duration: 100 },
        { graphic: beeSprite.getSprite(6, 0), duration: 100 },
        { graphic: beeSprite.getSprite(7, 0), duration: 100 },
      ],
    });
    this.swarmingAnim = new Animation({
      frames: [
        { graphic: beeSprite.getSprite(0, 1), duration: 100 },
        { graphic: beeSprite.getSprite(1, 1), duration: 100 },
        { graphic: beeSprite.getSprite(2, 1), duration: 100 },
        { graphic: beeSprite.getSprite(3, 1), duration: 100 },
        { graphic: beeSprite.getSprite(4, 1), duration: 100 },
        { graphic: beeSprite.getSprite(5, 1), duration: 100 },
        { graphic: beeSprite.getSprite(6, 1), duration: 100 },
        { graphic: beeSprite.getSprite(7, 1), duration: 100 },
        { graphic: beeSprite.getSprite(8, 1), duration: 100 },
      ],
      strategy: "loop",
    });
    const one = smallHiveSrites.getSprite(0, 1);
    const oneOne = smallHiveSrites.getSprite(2, 1);

    const two = smallHiveSrites.getSprite(1, 1);

    const twoOne = bigHiveSrites.getSprite(1, 0);
    const oneTwo = bigHiveSrites.getSprite(0, 0);
    const twoTwo = bigHiveSrites.getSprite(2, 0);
    const oneThree = bigHiveSrites.getSprite(3, 0);
    const twoThree = bigHiveSrites.getSprite(4, 0);
    const oneFour = bigHiveSrites.getSprite(5, 0);
    const twoFour = bigHiveSrites.getSprite(0, 1);
    const oneFive = bigHiveSrites.getSprite(1, 1);

    this.graphics.add("one", one);
    this.graphics.add("oneOne", oneOne);
    this.graphics.add("two", two);
    this.graphics.add("twoOne", twoOne);
    this.graphics.add("oneTwo", oneTwo);
    this.graphics.add("twoTwo", twoTwo);
    this.graphics.add("oneThree", oneThree);
    this.graphics.add("twoThree", twoThree);
    this.graphics.add("oneFour", oneFour);
    this.graphics.add("twoFour", twoFour);
    this.graphics.add("oneFive", oneFive);
    this.flyingActor.graphics.add("flying", flying);
    this.flyingActor.graphics.add("swarming", this.swarmingAnim);
    this.flyingActor.graphics.use("flying");

    this.activeSprite = getHiveSprite(this.hiveStats);
    console.log("activeSprite is : ", this.hiveStats);
    this.graphics.use(this.activeSprite);
    this.addChild(this.flyingActor);
    this.swarmingAnim &&
      this.swarmingAnim.events.on("loop", () => {
        console.log("swarmingAnim loop");
        this.swarmIteration++;
        if (this.swarmIteration >= 10) {
          //stop swarm
          console.log("stopping swarmingAnim");
          this.swarming = false;
          this.swarmIteration = 0;
        }
      });
  }
  onActivate() {
    this.activeSprite = getHiveSprite(this.hiveStats);
    console.log("activeSprite is : ", this.hiveStats);
    this.graphics.use(this.activeSprite);
    if (this.hiveStats.alive) {
      this.addChild(this.flyingActor);
    }
  }
  swarm() {
    console.log("inside swarm in hive actor: swarmcheck");
    this.swarming = true;
  }
  createProgressIndication() {
    let hives = hiveState.getHives();

    console.log("hiveProgress: hives: ", hives);
    this.indication = document.getElementById("hive-indication");
    this.indication.classList.add("active");
    let hive = hives.find((obj) => {
      return obj.birth == this.hiveStats.birth;
    });
    console.log("from createprogress, dead or alive: ", hive.alive);
    this.alive = hive.alive;
    let broodProgress = this.getBroodProgress(hive);
    let foodProgress = this.getFoodProgress(hive);
    let honeyProgress = this.getHoneyProgress(hive);
    let beesProgress = this.getBeesProgress(hive);
    this.indication.innerHTML = `
    <div id="indication">
    <h1>Hive: ${hive.id}</h1>
    <div class="stat-indication"><p>Brood:</p><div class="possible"></div><div class="indication" style="width:${broodProgress}px" ></div></div>
    <div class="stat-indication"><p>Bees:</p><div class="possible"></div><div class="indication" style="width:${beesProgress}px" ></div></div>
    <div class="stat-indication"><p>Food:</p><div class="possible"></div><div class="indication" style="width:${foodProgress}px" ></div></div>
    <div class="stat-indication"><p>Honey:</p><div class="possible"></div><div class="indication" style="width:${honeyProgress}px"></div></div>
    <p class="explanation">SPACE> Hive Menu <br/>F> Feed</p>
    </div>
    `;
  }
  onPostUpdate() {
    if (!this.alive) {
      this.flyingActor.graphics.hide();
    } else {
      if (this.swarming) {
        this.flyingActor.graphics.use("swarming");
      } else {
        this.flyingActor.graphics.use("flying");
      }
    }
  }

  getFoodProgress(hive) {
    let foodCount = hive.foodFrames.count;
    let frames = 10;
    const foodStats = (foodCount / frames) * 170;

    return roundDown(foodStats);
  }
  getBroodProgress(hive) {
    console.log("progress: hive is: ", hive);
    let broodCount = hive.broodFrames.count;
    let frames = hive.overallFrames.queenAccess;
    const broodStats = (broodCount / frames) * 170;
    return roundDown(broodStats);
  }
  getHoneyProgress(hive) {
    let honeyCount = hive.honeyFrames.count;
    let frames =
      parseFloat(hive.overallFrames.count) -
      parseFloat(hive.overallFrames.queenAccess);

    const honeyStats = (honeyCount / frames) * 170;
    return roundDown(honeyStats);
  }
  getBeesProgress(hive) {
    let beesCount = hive.beeFrames.count;
    let frames = hive.overallFrames.count;
    const beeStats = (beesCount / frames) * 170;
    return roundDown(beeStats);
  }
}
